import { render, staticRenderFns } from "./ProductDetails-buyer.vue?vue&type=template&id=125d2bc0"
import script from "./ProductDetails-buyer.vue?vue&type=script&lang=js"
export * from "./ProductDetails-buyer.vue?vue&type=script&lang=js"
import style0 from "./ProductDetails-buyer.vue?vue&type=style&index=0&id=125d2bc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports